import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Card, { CardHeader } from '../../common/Card';
import Button from '../../common/Button';
import { useShopPayments } from '../hooks/useShopPayments';

const COPY = {
  not_connected: {
    text: 'Let customers pay deposits and bills from their estimate link. Money goes straight to your own Stripe account.',
    button: 'Connect Stripe',
  },
  setting_up: {
    text: 'Finish setting up Stripe to take payments.',
    button: 'Continue setup',
  },
  needs_attention: {
    text: 'Stripe needs more information before you can take payments.',
    button: 'Open Stripe setup',
  },
};

// Settings -> Card payments. Owns its data; renders nothing when the
// feature is off (the account endpoint 404s).
const PaymentsSection = () => {
  const { account, enabled, loading, error, checking, connecting, connect } = useShopPayments();
  const [country, setCountry] = useState('');

  if (!enabled) return null;

  const copy = account && COPY[account.state];
  const notConnected = account && account.state === 'not_connected';
  const chosenCountry = country || (account && account.default_country) || 'US';

  return (
    <Card padding={false}>
      <CardHeader className="p-6 pb-0" title="Card payments" />
      <div className="p-6 space-y-3">
        {loading && <p className="text-small text-ink-muted">Loading…</p>}
        {error && <p role="alert" className="text-small text-danger">{error}</p>}

        {account && !account.has_payment_tier && (
          <p className="text-body text-ink-muted">
            Card payments need a paid CROW plan.{' '}
            <Link to="/billing" className="text-accent underline">Upgrade</Link>
          </p>
        )}

        {account && account.has_payment_tier && checking && (
          <p role="status" className="text-body text-ink-muted">Checking with Stripe…</p>
        )}

        {account && account.has_payment_tier && !checking && account.state === 'ready' && (
          <p className="text-body text-ink">
            {account.currency
              ? `Ready — payments in ${account.currency.toUpperCase()}`
              : 'Ready — payments enabled'}
          </p>
        )}

        {account && account.has_payment_tier && !checking && copy && (
          <div className="space-y-3">
            <p className="text-body text-ink-muted">{copy.text}</p>
            {notConnected && (
              <label className="block text-sm font-medium text-ink">
                <span className="block mb-1">Where is your shop?</span>
                <select
                  aria-label="Where is your shop?"
                  value={chosenCountry}
                  onChange={(e) => setCountry(e.target.value)}
                  disabled={connecting}
                  className="w-full sm:w-auto min-h-touch border border-border-strong rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-accent"
                >
                  <option value="US">United States</option>
                  <option value="CA">Canada</option>
                </select>
              </label>
            )}
            <Button
              variant="primary"
              onClick={() => (notConnected ? connect(chosenCountry) : connect())}
              loading={connecting}
            >
              {copy.button}
            </Button>
          </div>
        )}
      </div>
    </Card>
  );
};

export default PaymentsSection;
